/* Component Dependencies */
var destinationHeroImageTemplate = require('templates/destinationHeroImage.hbs');
var AriesComponent = require('libs/aries-component');
var fontResizer = require('utils/fontSizeResize');
require('libs/jquery.dotdotdot');

AriesComponent.create({
  type: 'destinationHeroImage',
  template: {
    'destinationHeroImage': destinationHeroImageTemplate
  },
  bindEvents: function() {
    this.initFontResize();

    this.$el.find('.t-ito-text').dotdotdot({
      watch: 'window'
    });
  },
  options: {
    'MIN_DESKTOP_FONT_SIZE': 90
  },
  initFontResize: function() {
    fontResizer(this.$el, '.t-hero-title', this.options.MIN_DESKTOP_FONT_SIZE)
  }
});
